import { Amplify } from 'aws-amplify'
import { getSignOutRedirectUrls } from 'src/features/auth/utils/getSignOutRedirectUrl'

export const initialize = () => {
  const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN
  const signOutRedirectUrls = getSignOutRedirectUrls()

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
        // OAuth設定（SSO用）- cognitoDomainが設定されている場合のみ有効
        ...(cognitoDomain && {
          loginWith: {
            oauth: {
              domain: cognitoDomain,
              scopes: ['openid', 'email', 'profile'],
              redirectSignIn: [
                `${import.meta.env.VITE_WEB_DOMAIN}/sso/callback`,
              ],
              redirectSignOut: signOutRedirectUrls,
              responseType: 'code' as const,
            },
          },
        }),
      },
    },
  })
}
